export default "__VITE_ASSET__CmpuQ2cS__"